import { ActionIcon, Button, createTheme, type MantineColorsTuple } from '@mantine/core';
import { tokens, paletteForMantine } from './ui/tokens.ts';

/**
 * Mantine theme is derived from the style SSOT (`src/ui/tokens.ts`).
 * No hex / shadow / radius literal here — everything flows from tokens.
 *
 * Touch-target overrides:
 *   ActionIcon and small Buttons get a CSS-min-height of
 *   `tokens.interaction.touchTargetMin` (44px, WCAG 2.5.5 minimum) so
 *   thumb taps on phones don't miss. Desktop visual size keeps Mantine's
 *   default — only the hit area grows. Achieved via `min-width` /
 *   `min-height` on the root, NOT a `size` override (that would shrink
 *   icon glyphs).
 */
const TOUCH_MIN = `${tokens.interaction.touchTargetMin}px`;

export const theme = createTheme({
  primaryColor: tokens.color.mantine.primary,
  colors: {
    navy: [...paletteForMantine.navy] as unknown as MantineColorsTuple,
    sky: [...paletteForMantine.sky] as unknown as MantineColorsTuple,
  },
  white: tokens.color.white,
  black: tokens.color.ink,
  defaultRadius: 'lg',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "PingFang TC", "Noto Sans TC", "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: 'inherit',
    fontWeight: '700',
  },
  components: {
    ActionIcon: ActionIcon.extend({
      styles: {
        root: { minWidth: TOUCH_MIN, minHeight: TOUCH_MIN },
      },
    }),
    Button: Button.extend({
      styles: {
        root: { minHeight: TOUCH_MIN },
      },
    }),
  },
  other: {
    pageBackground: tokens.color.pageBackground,
    heroBackground: tokens.gradient.hero,
    heroText: tokens.color.heroText,
    heroSubtext: tokens.color.heroSubtext,
    softShadow: tokens.shadow.soft,
    cardShadow: tokens.shadow.card,
    headerSurface: tokens.color.headerSurface,
    headerBorder: tokens.color.headerBorder,
  },
});
